import { createFileRoute, Link } from "@tanstack/react-router";
import { AccountShell } from "@/components/customer/AccountShell";
import { SignOutButton } from "@/components/customer/SignOutButton";
import { useCustomerSession } from "@/hooks/useCustomerSession";
import { useCustomerAddresses, useCustomerProfile } from "@/hooks/useCustomerAccount";

export const Route = createFileRoute("/_customer/account/")({
  component: AccountDashboard,
});

function AccountDashboard() {
  const { user } = useCustomerSession();
  const { profile, isLoading } = useCustomerProfile();
  const { addresses } = useCustomerAddresses();
  const defaultAddress = addresses.find((a) => a.is_default) ?? null;

  return (
    <AccountShell
      title={profile?.full_name ? `Hello, ${profile.full_name}` : "Your account"}
      description="Manage your personal details and delivery addresses."
    >
      <div className="grid gap-4 sm:grid-cols-2">
        <section className="rounded-xl border border-border/60 bg-card p-5">
          <h2 className="text-sm font-semibold">Profile</h2>
          <dl className="mt-3 space-y-1 text-sm text-muted-foreground">
            <div>
              <dt className="sr-only">Name</dt>
              <dd>{isLoading ? "Loading…" : (profile?.full_name ?? "Name not set")}</dd>
            </div>
            <div>
              <dt className="sr-only">Email</dt>
              <dd>{profile?.email ?? user?.email ?? "—"}</dd>
            </div>
            <div>
              <dt className="sr-only">Phone</dt>
              <dd>{profile?.phone ?? "Phone not set"}</dd>
            </div>
          </dl>
          <Link
            to="/account/profile"
            className="mt-4 inline-flex text-sm font-medium text-primary hover:underline"
          >
            Edit profile
          </Link>
        </section>

        <section className="rounded-xl border border-border/60 bg-card p-5">
          <h2 className="text-sm font-semibold">Default delivery address</h2>
          <p className="mt-3 text-sm text-muted-foreground">
            {defaultAddress
              ? [
                  defaultAddress.address_line1,
                  defaultAddress.address_line2,
                  defaultAddress.delivery_area_name,
                  defaultAddress.city,
                ]
                  .filter(Boolean)
                  .join(", ")
              : "No saved address yet."}
          </p>
          <Link
            to="/account/addresses"
            className="mt-4 inline-flex text-sm font-medium text-primary hover:underline"
          >
            Manage addresses
          </Link>
        </section>
      </div>

      <div className="mt-6">
        <SignOutButton />
      </div>
    </AccountShell>
  );
}
